export const COLOR_PALETTE = 'DEFAULT';
